import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { ExecuteOperationOnPipe, ModelWithForm, ResetFormOnPipe, useValue } from '@morningtrain/react-resources'
import { Translation, Translator } from '@morningtrain/react-translations'
import SmartviewContentSection from 'widgets/smartviews/partials/SmartviewContentSection'
import { Fieldset } from 'layouts/index'
import * as Fields from 'support/fields'
import FilePreview from 'widgets/files/FilePreview'
import * as UI from 'ui'
import { FieldWrapper } from '@morningtrain/react-fields'
import { NavigateOnPipe } from '@morningtrain/react-navigation'
import DeleteModelOnClick from 'support/actions/generic/DeleteModelOnClick'
import { ResetSmartviewOnPipe } from '@morningtrain/react-smartviews'

export default function FileSmartview (props) {
  const fileId = useValue('id')

  return (
    <Translator namespace='smartviews.file'>
      <ModelWithForm resourceName='files.files' id={fileId}>
        <Smartview
          header={(
            (fileId) ? <Translation name='edit_title' /> : <Translation name='create_title' />
            )}
          footer={(
            <UI.ButtonWrap>
              <DeleteModelOnClick
                pipes={(
                  <>
                    <ExecuteOperationOnPipe namespace='api' resourceName='files.files' operationName='index' />
                    <ResetSmartviewOnPipe />
                  </>
                )}
              >
                <UI.SquareButton color='red' big>
                  <UI.Icons.Trash className='w-4 h-4' />
                </UI.SquareButton>
              </DeleteModelOnClick>
              <UI.SubmitButton>
                <Translation name='generic.save' />
              </UI.SubmitButton>
            </UI.ButtonWrap>
      )}
        >
          <SmartviewContentSection>
            <Fieldset>
              <Fields.Hidden name='file_tag_id' defaultValue={props.fileTagId} />
              <Fields.Input
                name='name'
                label={<Translation name='fields.name.label' />}
              />
              <Fields.Select
                name='locale'
                enum='language'
                label={<Translation name='fields.locale.label' />}
              />
              <Fields.File
                name='file'
                label={<Translation name='fields.file.label' />}
              />
              <Fields.DepartmentsField
                name='department_ids'
                label={<Translation name='fields.departments.label' />}
                multiple
              />
              <FieldWrapper>
                <FilePreview />
              </FieldWrapper>
            </Fieldset>
          </SmartviewContentSection>

        </Smartview>

        {(
          (fileId) ? null : <ResetFormOnPipe />
        )}
        <ExecuteOperationOnPipe namespace='api' resourceName='files.files' operationName='index' />
      </ModelWithForm>
    </Translator>
  )
}
